import { Flex, Box, Message, Loading } from 'components/ui';
import { BigNumber } from 'ethers';
import useMixpassSale from 'hooks/useMixpassSale';
import capitalize from 'lodash/capitalize';
import * as React from 'react';
import { futuraChainId } from 'utils/config';
import { getAllocation } from 'utils/whitelist';
import BuyWhitelist from './BuyWhitelist';
import partyIcon from 'img/party.svg';
import { Whitelist, WHITELIST_TITLE } from './mixpassConfig';

interface MixpassWhitelistProps {
  whitelist: string;
}

const MixpassWhitelist: React.FC<MixpassWhitelistProps> = ({ whitelist }) => {
  const {
    isEnabled,
    userClaimInfo,
    isLoading,
    claimStatus,
    buy,
    price,
    remainingSupply,
    paymentToken,
  } = useMixpassSale(whitelist);

  const isSoldOut = remainingSupply && remainingSupply.eq(0);
  const userAllocation = getAllocation(userClaimInfo);

  if (isEnabled && userAllocation <= 0) {
    return null;
  }

  return (
    <Box
      mt="5"
      py="2"
      px="3"
      mr="3"
      minHeight="150px"
      width={['100%', '100%', '50%']}
      borderRight={['none', 'none', whitelist === Whitelist.community ? `1px solid #666` : 'none']}
    >
      <Box fontSize={2} fontWeight="bold" mb="2" width="100%">
        {capitalize(WHITELIST_TITLE[whitelist])} Whitelist
      </Box>
      {isLoading ? (
        <Loading />
      ) : (
        <>
          <Box mt={4}>
            {isEnabled && !claimStatus && price && !isSoldOut && userAllocation > 0 && (
              <BuyWhitelist
                paymentToken={paymentToken}
                maxCount={userAllocation}
                onClick={buy}
                price={price}
                remainingSupply={remainingSupply || BigNumber.from(0)}
                networkId={futuraChainId}
                showAllocationWarning={true}
              />
            )}
            {!isEnabled && (
              <Message color="black">Sale is not active yet.</Message>
            )}
            {claimStatus && (
              <Flex>
                <img src={partyIcon} alt="party" />
                <Box ml={3}>
                  Congrats! <br /> You have already purchased
                </Box>
              </Flex>
            )}
            {isSoldOut && <Message color="black">We have sold out</Message>}
          </Box>
        </>
      )}
    </Box>
  );
};

export default MixpassWhitelist;
